import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {
  Branch, CaseB, Certification, Change, Chinacourt,
  Company, CompanyPartner, Copyright,
  EnterpIntroductionServiceService, Execute, Financing, FinancingTax, InvestInfo, Liquidation, LoseCreditExecute,
  MPledge, NewsInfo,
  OperationTender,
  OpException,
  PatentDetail, Penalty, Pledge, Product,
  RecruitInfo, ScopeChange, SoftwareCopyrights, Spotcheck, TmInfo, Website
} from "../../services/enterp-introduction-service.service";
import {Page} from "../../models/page";
import {PageService} from "../../services/page.service";
import {HttpCommonService} from "../../services/http-common.service";
import {ActivatedRoute, Router} from "@angular/router";
import {GlobalService} from "../../services/global.service";
import {NzMessageService, NzModalService} from "ng-zorro-antd";
import {Title} from "@angular/platform-browser";
import '../../../assets/plugins/d3/d3.min.js';
import * as html2canvas from 'html2canvas';
import {error} from "util";
declare var d3: any;


@Component({
  selector: 'app-enterp-basic-archives',
  templateUrl: './enterp-basic-archives.component.html',
  styleUrls: ['./enterp-basic-archives.component.css']
})
export class EnterpBasicArchivesComponent implements OnInit, OnDestroy, AfterViewInit {

  params: Params = new Params();
  companyInfo: Company;//基础信息
  companyPartnersResult: any = {};//股东及出资方
  investInfoResult: any = {};//对外投资
  branchResult: any = {};//分支机构
  changeResult: any = {};//工商变更
  scopeChangeResult: any = {};//经营范围变更
  patentDetailResult: any = {};//专利信息
  softwareCopyrightsResult: any = {};//软件著作权
  tmInfoResult: any = {};//商标信息
  mPledgeResult: any = {};//动产抵押
  pledgeResult: any = {};//股权出质
  //知识产权出质暂无信息
  liquidationResult: any = {};//清算信息------暂无信息
  opExceptionResult: any = {};//工商异常名录
  executeResult: any = {};//被执行人信息
  loseCreditExecuteResult: any = {};//失信被执行信息
  caseResult: any = {};//裁判文书信息
  chinacourtResult: any = {};//法院公告信息
  newsInfoResult: any = {};//企业舆情信息
  //企业招投标信息缺失
  recruitInfoResult: any = {};//招聘信息
  operationTenderResult: any = {};//招投标
  userType: any;//用户类型
  xhCode: any;//新华信用码

  isFromQi: boolean;
  companyId: any; // 企业id
  companyName: any; // 企业名称
  aType: any; // 跳转类别，1表示从我的主页跳转


  copyrightResult: any = {};//著作权信息
  websiteResult: any = {};//网站信息
  certificationResult: any = {};//证书信息
  financingResult: any = {};//融资信息
  financingTaxResult: any = {};//财务信息
  productResult: any = {};//产品信息
  spotcheckResult: any = {};//抽查信息
  penaltyResult: any = {};//行政处罚信息

  gqlxxInit = false; // 股权类信息
  lsygInit = false; // 历史沿革
  zscqxxInit = false; // 知识产权信息
  sbxxInit = false; // 商标信息
  lyjgxxInit = false; // 履约结果信息
  sfxxInit = false; // 司法信息
  yqhqtgkxxInit = false; // 舆情和其他公开信息
  jyzkInit = false; //经营状况

  //加载框
  _isSpinning = false;

  showDownloadBtn = false;

  canvasImg = null; // d3生成的base64编码

  userId: any;
  userName: any;
  fromType: any;

  constructor(private guDongService: EnterpIntroductionServiceService,
              private pageService: PageService, private httpService: HttpCommonService,
              private routerInfo: ActivatedRoute, private globalService: GlobalService,
              private enterpIntroductionService: EnterpIntroductionServiceService,
              private router: Router, private showAlert: NzModalService,
              private showMsg: NzMessageService, private showConfirm: NzModalService,
              private titleService: Title) {
    this.userId = this.routerInfo.snapshot.queryParams['userId'];
    this.userName = this.routerInfo.snapshot.queryParams['userName'];
    this.fromType = this.routerInfo.snapshot.queryParams['fromType'];

    this.guDongService.isFromQi = true;// 使用企查查接口
    this.isFromQi = this.guDongService.isFromQi;
  }


  ngOnInit() {
    this.titleService.setTitle('企业档案');
    this.searchXhCode();
    this.routerInfo.queryParams.subscribe((params: Params) => {
      this.enterpIntroductionService.updateTabActive(0);
      this.aType = params['aType'];
      // 从我的主页跳转来
      if (this.aType == 1) {
        this.companyId = this.globalService.getUserInfo("_companyId");
      } else {
        this.companyId = this.routerInfo.snapshot.queryParams['companyId'];
      }
      this.userType = this.globalService.getUserInfo("_userType");

      this.pageService.pageChange.debounceTime(0).subscribe(
        page => {
          // console.log('自己的订阅pChange,page:'+JSON.stringify(page));
          if (page.pageId == 'recruitInfoId') {
            this.params.page = page;
            this.recruitInfo();
          }

          if (page.pageId == 'newsInfoId') {
            this.params.page = page;
            this.newsInfo();
          }

          if (page.pageId == 'chinacourtId') {
            this.params.page = page;
            this.chinacourt();
          }

          if (page.pageId == 'caseBExecuteId') {
            this.params.page = page;
            this.caseB();
          }
          if (page.pageId == 'loseCreditExecuteId') {
            this.params.page = page;
            this.loseCreditExecute();
          }
          if (page.pageId == 'executeId') {
            this.params.page = page;
            this.execute();
          }
          if (page.pageId == 'opExceptionId') {
            this.params.page = page;
            this.opException();
          }

          if (page.pageId == 'liquidationId') {
            this.params.page = page;
            this.liquidation();
          }

          if (page.pageId == 'pledgeId') {
            this.params.page = page;
            this.pledge();
          }

          if (page.pageId == 'mPledgeId') {
            this.params.page = page;
            this.mPledge();
          }

          if (page.pageId == 'tmInfoId') {
            this.params.page = page;
            this.tmInfo();
          }

          if (page.pageId == 'softwareCopyrightsId') {
            this.params.page = page;
            this.softwareCopyrights();
          }


          if (page.pageId == 'patentDetailId') {
            this.params.page = page;
            this.patentDetail();
          }

          if (page.pageId == 'companyPartnersId') {
            this.params.page = page;
            this.guquanjiegou();
          }
          if (page.pageId == 'investInfoId') {
            this.params.page = page;
            this.investInfo();
          }

          if (page.pageId == 'branchId') {
            this.params.page = page;
            this.branch();
          }

          if (page.pageId == 'scopeChangeId') {
            this.params.page = page;
            this.scopeChange();
          }
          if (page.pageId == 'changeId') {
            this.params.page = page;
            this.change();
          }

          if (page.pageId == 'operationTenderId') {
            this.params.page = page;
            this.operationTender();
          }

          if (page.pageId == 'copyrightId') {//著作权信息
            this.params.page = page;
            this.getOperationCopyright();
          }
          if (page.pageId == 'websiteId') {//网站信息
            this.params.page = page;
            this.getOperationWebsite();
          }
          if (page.pageId == 'certificationId') {//证书信息
            this.params.page = page;
            this.getAssetCertification();
          }
          if (page.pageId == 'financingId') {//融资信息
            this.params.page = page;
            this.getOperationFinancing();
          }
          if (page.pageId == 'financingTaxId') {//财务信息
            this.params.page = page;
            this.getOperationFinancingTax();
          }
          if (page.pageId == 'productId') {//产品信息
            this.params.page = page;
            this.getOperationProduct();
          }
          if (page.pageId == 'spotcheckId') {//抽查信息
            this.params.page = page;
            this.getOperationSpotcheck();
          }
          if (page.pageId == 'penaltyId') {//行政处罚信息
            this.params.page = page;
            this.getDetailOperationPenalty();
          }

        }
      );

      this.ready();


      if (this.isFromQi) {
        this.guDongService.getCompanyName(this.companyId).subscribe(data => {
          if (data.data.returnData != null) {
            this.companyName = data.data.returnData[0].name;
            //console.log(this.companyName)
            this.getCompany();// 企查查接口需先获取companyName
          }
        });
      } else {
        this.getCompany();// 正常接口无需先获取companyName
      }
    });

    // 点击切换显示当前点击的位置的效果
    $('.menu_body a').on('click', function () {
      $(this).addClass('active');
      $(this).siblings().removeClass('active');
    });

    $('.menu_head').on('click', function () {
      $(this).next('.menu_body').find('a:first').addClass('active').siblings().removeClass('active');
    });
  }

  ngOnDestroy(): void {
    this.guDongService.isFromQi = false;
  }

  searchXhCode() {
    this.routerInfo.queryParams.subscribe((params: Params) => {
        this.aType = params['aType'];
        // 从我的主页跳转来
        if (this.aType == 1) {
          this.companyId = this.globalService.getUserInfo("_companyId");
        } else {
          this.companyId = this.routerInfo.snapshot.queryParams['companyId'];
        }
        // console.log(3333333);
        this.httpService.get('/user/center/myMessage/getXhCodeByCompanyId', {companyId: this.companyId})
          .subscribe(data => {
            if (data.data != null && data.data != '') {
              this.xhCode = data.data.xhCode;
            }
            // console.log(data);
            // console.log(1111111111111111111111111);
          });
      }
    );
  }

  // 基本信息
  getCompany() {
    this.guDongService.getCompany(this.companyId, this.companyName).subscribe(data => {
      //console.log(data)
      if (data.stateCode == '60111') {
        if (this.isFromQi) {
          data.data.Result.imgUrl = data.data.imgUrl;
        }
        this.companyInfo = new Company(this.isFromQi ? data.data.Result : data.data.returnData[0], this.isFromQi);
        this.scrollInvokeData();
      } else if (this.isFromQi) {//企查查没有数据
        this.isFromQi = false;
        this.guDongService.isFromQi = false;// 使用自己平台接口
        this.getCompany();
      }
    }, (err) => {
    });
  }

  //招聘信息
  recruitInfo() {
    let params = {companyId: this.companyId, companyName: this.companyName, page: this.params.page};
    this.guDongService.getBasicInfo(params, 17).subscribe(data => {
      //console.log('招聘信息');
      //console.log(data);
      if (data.stateCode == "60111") {
        let list = [];
        if (this.isFromQi) {
          this.recruitInfoResult.totalCount = data.data.Paging.TotalRecords;
          data.data.Result.forEach(item => list.push(new RecruitInfo(item, this.isFromQi)));
        } else {
          this.recruitInfoResult.totalCount = data.data.totalCount;
          data.data.returnData.forEach(item => list.push(new RecruitInfo(item, this.isFromQi)));
        }
        this.recruitInfoResult.page = params.page;
        this.recruitInfoResult.list = list;
      } else {
        this.recruitInfoResult = null;
      }
    }, (err) => {
      //this.router.navigateByUrl("");
      // console.log(55555);
    });
  }

  //企业舆情信息
  newsInfo() {
    let params = {companyId: this.companyId, companyName: this.companyName, page: this.params.page};
    this.guDongService.getBasicInfo(params, 16).subscribe(data => {
      //console.log('企业舆情信息');
      //console.log(data);
      if (data.stateCode == "60111") {
        let list = [];
        if (this.isFromQi) {
          this.newsInfoResult.totalCount = data.data.Paging.TotalRecords;
          data.data.Result.forEach(item => list.push(new NewsInfo(item, this.isFromQi)));
        } else {
          this.newsInfoResult.totalCount = data.data.totalCount;
          data.data.returnData.forEach(item => list.push(new NewsInfo(item, this.isFromQi)));
        }
        this.newsInfoResult.page = params.page;
        this.newsInfoResult.list = list;
      } else {
        this.newsInfoResult = null;
      }
    }, (err) => {
      //this.router.navigateByUrl("");
    });
  }

  //法院公告信息
  chinacourt() {
    let params = {companyId: this.companyId, companyName: this.companyName, page: this.params.page};
    this.guDongService.getBasicInfo(params, 15).subscribe(data => {
      //console.log('法院公告信息');
      //console.log(data);
      if (data.stateCode == "60111") {
        let list = [];
        if (this.isFromQi) {
          this.chinacourtResult.totalCount = data.data.Paging.TotalRecords;
          data.data.Result.forEach(item => list.push(new Chinacourt(item, this.isFromQi)));
        } else {
          this.chinacourtResult.totalCount = data.data.totalCount;
          data.data.returnData.forEach(item => list.push(new Chinacourt(item, this.isFromQi)));
        }
        this.chinacourtResult.page = params.page;
        this.chinacourtResult.list = list;
        this.chinacourtResult.list.forEach(item=>{
          this.guDongService.getCompanyByName(item.litigant).subscribe(result=>{
            if (result.data) {
              item.isCompany = true;
            }
          });
        });
      } else {
        this.chinacourtResult = null;
      }
    }, (err) => {
      //this.router.navigateByUrl("");
    });
  }

  //裁判文书信息
  caseB() {
    let params = {companyId: this.companyId, companyName: this.companyName, page: this.params.page};
    this.guDongService.getBasicInfo(params, 14).subscribe(data => {
      //console.log('裁判文书信息');
      //console.log(data);
      if (data.stateCode == "60111") {
        let list = [];
        if (this.isFromQi) {
          this.caseResult.totalCount = data.data.Paging.TotalRecords;
          data.data.Result.forEach(item => list.push(new CaseB(item, this.isFromQi)));
        } else {
          this.caseResult.totalCount = data.data.totalCount;
          data.data.returnData.forEach(item => list.push(new CaseB(item, this.isFromQi)));
        }
        this.caseResult.page = params.page;
        this.caseResult.list = list;
      } else {
        this.caseResult = null;
      }
    }, (err) => {
      //this.router.navigateByUrl("");
    });
  }

  //失信被执行信息
  loseCreditExecute() {
    let params = {companyId: this.companyId, companyName: this.companyName, page: this.params.page};
    this.guDongService.getBasicInfo(params, 13).subscribe(data => {
      //console.log('失信被执行信息');
      //console.log(data);
      if (data.stateCode == "60111") {
        let list = [];
        if (this.isFromQi) {
          this.loseCreditExecuteResult.totalCount = data.data.Paging.TotalRecords;
          data.data.Result.forEach(item => list.push(new LoseCreditExecute(item, this.isFromQi)));
        } else {
          this.loseCreditExecuteResult.totalCount = data.data.totalCount;
          data.data.returnData.forEach(item => list.push(new LoseCreditExecute(item, this.isFromQi)));
        }
        this.loseCreditExecuteResult.page = params.page;
        this.loseCreditExecuteResult.list = list;
      } else {
        this.loseCreditExecuteResult = null;
      }
    }, (err) => {
      //this.router.navigateByUrl("");
    });
  }

  //被执行人信息
  execute() {
    let params = {companyId: this.companyId, companyName: this.companyName, page: this.params.page};
    this.guDongService.getBasicInfo(params, 12).subscribe(data => {
      //console.log('被执行人信息');
      //console.log(data);
      if (data.stateCode == "60111") {
        let list = [];
        if (this.isFromQi) {
          this.executeResult.totalCount = data.data.Paging.TotalRecords;
          data.data.Result.forEach(item => list.push(new Execute(item, this.isFromQi)));
        } else {
          this.executeResult.totalCount = data.data.totalCount;
          data.data.returnData.forEach(item => list.push(new Execute(item, this.isFromQi)));
        }
        this.executeResult.page = params.page;
        this.executeResult.list = list;
      } else {
        this.executeResult = null;
      }
    }, (err) => {
      //this.router.navigateByUrl("");
    });
  }

  //工商异常名录
  opException() {
    let params = {companyId: this.companyId, companyName: this.companyName, page: this.params.page};
    this.guDongService.getBasicInfo(params, 11).subscribe(data => {
      //console.log('工商异常名录');
      //console.log(data);
      if (data.stateCode == "60111") {
        let list = [];
        if (this.isFromQi) {
          this.opExceptionResult.totalCount = data.data.totalRecords;
          data.data.list.forEach(item => list.push(new OpException(item, this.isFromQi)));
        } else {
          this.opExceptionResult.totalCount = data.data.totalCount;
          data.data.returnData.forEach(item => list.push(new OpException(item, this.isFromQi)));
        }
        this.opExceptionResult.page = params.page;
        this.opExceptionResult.list = list;
      } else {
        this.opExceptionResult = null;
      }
    }, (err) => {
      //this.router.navigateByUrl("");
    });

  }

  //清算信息
  liquidation() {
    let params = {companyId: this.companyId, companyName: this.companyName, page: this.params.page};
    this.guDongService.getBasicInfo(params, 18).subscribe(data => {
      if (data.stateCode == "60111") {
        let list = [];
        if (this.isFromQi) {
          this.liquidationResult.totalCount = data.data.totalRecords;
          data.data.list.forEach(item => list.push(new Liquidation(item, this.isFromQi)));
        } else {
          this.liquidationResult.totalCount = data.data.totalCount;
          data.data.returnData.forEach(item => list.push(new Liquidation(item, this.isFromQi)));
        }
        this.liquidationResult.page = params.page;
        this.liquidationResult.list = list;
      } else {
        this.liquidationResult = null;
      }
    }, (err) => {
      //this.router.navigateByUrl("");
    });
  }

  //股权出质
  pledge() {
    let params = {companyId: this.companyId, companyName: this.companyName, page: this.params.page};
    this.guDongService.getBasicInfo(params, 10).subscribe(data => {
      //console.log('股权出质');
      //console.log(data);
      if (data.stateCode == "60111") {
        let list = [];
        if (this.isFromQi) {
          this.pledgeResult.totalCount = data.data.totalRecords;
          data.data.list.forEach(item => list.push(new Pledge(item, this.isFromQi)));
        } else {
          this.pledgeResult.totalCount = data.data.totalCount;
          data.data.returnData.forEach(item => list.push(new Pledge(item, this.isFromQi)));
        }
        this.pledgeResult.page = params.page;
        this.pledgeResult.list = list;
      } else {
        this.pledgeResult = null;
      }
    }, (err) => {
      //this.router.navigateByUrl("");
    });
  }

  //动产抵押
  mPledge() {
    let params = {companyId: this.companyId, companyName: this.companyName, page: this.params.page};
    this.guDongService.getBasicInfo(params, 9).subscribe(data => {
      //console.log('动产抵押');
      //console.log(data);
      if (data.stateCode == "60111") {
        let list = [];
        if (this.isFromQi) {
          this.mPledgeResult.totalCount = data.data.totalRecords;
          data.data.list.forEach(item => list.push(new MPledge(item, this.isFromQi)));
        } else {
          this.mPledgeResult.totalCount = data.data.totalCount;
          data.data.returnData.forEach(item => list.push(new MPledge(item, this.isFromQi)));
        }
        this.mPledgeResult.page = params.page;
        this.mPledgeResult.list = list;
      } else {
        this.mPledgeResult = null;
      }
    }, (err) => {
      //this.router.navigateByUrl("");
    });
  }

  //商标信息
  tmInfo() {
    let params = {companyId: this.companyId, companyName: this.companyName, page: this.params.page};
    this.guDongService.getBasicInfo(params, 8).subscribe(data => {
      //console.log('商标信息');
      //console.log(data);
      if (data.stateCode == "60111") {
        let list = [];
        if (this.isFromQi) {
          this.tmInfoResult.totalCount = data.data.Paging.TotalRecords;
          data.data.Result.forEach(item => list.push(new TmInfo(item, this.isFromQi)));
        } else {
          this.tmInfoResult.totalCount = data.data.totalCount;
          data.data.returnData.forEach(item => list.push(new TmInfo(item, this.isFromQi)));
        }
        this.tmInfoResult.page = params.page;
        this.tmInfoResult.list = list;
      } else {
        this.tmInfoResult = null;
      }
    }, (err) => {
      //this.router.navigateByUrl("");
    });
  }

  //软件著作权信息
  softwareCopyrights() {
    let params = {companyId: this.companyId, companyName: this.companyName, page: this.params.page};
    this.guDongService.getBasicInfo(params, 7).subscribe(data => {
      //console.log('软件著作权信息');
      //console.log(data);
      if (data.stateCode == "60111") {
        let list = [];
        if (this.isFromQi) {
          this.softwareCopyrightsResult.totalCount = data.data.Paging.TotalRecords;
          data.data.Result.forEach(item => list.push(new SoftwareCopyrights(item, this.isFromQi)));
        } else {
          this.softwareCopyrightsResult.totalCount = data.data.totalCount;
          data.data.returnData.forEach(item => list.push(new SoftwareCopyrights(item, this.isFromQi)));
        }
        this.softwareCopyrightsResult.page = params.page;
        this.softwareCopyrightsResult.list = list;
      } else {
        this.softwareCopyrightsResult = null;

      }
    }, (err) => {
      //this.router.navigateByUrl("");
    });
  }

  //专利信息
  patentDetail() {
    let params = {companyId: this.companyId, companyName: this.companyName, page: this.params.page};
    this.guDongService.getBasicInfo(params, 6).subscribe(data => {
      //console.log('专利信息');
      //console.log(data);
      if (data.stateCode == "60111") {
        let list = [];
        if (this.isFromQi) {
          this.patentDetailResult.totalCount = data.data.Paging.TotalRecords;
          data.data.Result.forEach(item => list.push(new PatentDetail(item, this.isFromQi)));
        } else {
          this.patentDetailResult.totalCount = data.data.totalCount;
          data.data.returnData.forEach(item => list.push(new PatentDetail(item, this.isFromQi)));
        }
        this.patentDetailResult.page = params.page;
        this.patentDetailResult.list = list;
      } else {
        this.patentDetailResult = null;
      }
    }, (err) => {
      //this.router.navigateByUrl("");
    });
  }

  //经营范围变更
  scopeChange() {
    let params = {companyId: this.companyId, companyName: this.companyName, page: this.params.page};
    this.guDongService.getBasicInfo(params, 5).subscribe(data => {
      //console.log('经营范围变更');
      //console.log(data);
      if (data.stateCode == "60111") {
        let list = [];
        if (this.isFromQi) {
          this.scopeChangeResult.totalCount = data.data.totalRecords;
          data.data.list.forEach(item => list.push(new ScopeChange(item, this.isFromQi)));
        } else {
          this.scopeChangeResult.totalCount = data.data.totalCount;
          data.data.returnData.forEach(item => list.push(new ScopeChange(item, this.isFromQi)));
        }
        this.scopeChangeResult.page = params.page;
        this.scopeChangeResult.list = list;
      } else {
        this.scopeChangeResult = null;
      }
    }, (err) => {
      //this.router.navigateByUrl("");
    });
  }

  //工商记录变更
  change() {
    let params = {companyId: this.companyId, companyName: this.companyName, page: this.params.page};
    this.guDongService.getBasicInfo(params, 4).subscribe(data => {
      //console.log('工商记录变更');
      //console.log(data);
      if (data.stateCode == "60111") {
        let list = [];
        if (this.isFromQi) {
          this.changeResult.totalCount = data.data.totalRecords;
          data.data.list.forEach(item => list.push(new Change(item, this.isFromQi)));
        } else {
          this.changeResult.totalCount = data.data.totalCount;
          data.data.returnData.forEach(item => list.push(new Change(item, this.isFromQi)));
        }
        this.changeResult.page = params.page;
        this.changeResult.list = list;
      } else {
        this.changeResult = null;
      }
    }, (err) => {
      //this.router.navigateByUrl("");
    });
  }

  //分支机构
  branch() {
    let params = {companyId: this.companyId, companyName: this.companyName, page: this.params.page};
    this.guDongService.getBasicInfo(params, 3).subscribe(data => {
      //console.log('分支机构');
      //console.log(data);
      if (data.stateCode == "60111") {
        let list = [];
        if (this.isFromQi) {
          this.branchResult.totalCount = data.data.totalRecords;
          data.data.list.forEach(item => list.push(new Branch(item, this.isFromQi)));
        } else {
          this.branchResult.totalCount = data.data.totalCount;
          data.data.returnData.forEach(item => list.push(new Branch(item, this.isFromQi)));
        }
        this.branchResult.page = params.page;
        this.branchResult.list = list;
        this.branchResult.list.forEach(item=>{
          this.guDongService.getCompanyByName(item.name).subscribe(result=>{
            if (result.data) {
              item.isCompany = true;
            }
          });
        });
      } else {
        this.branchResult = null;
      }

    }, (err) => {
      //this.router.navigateByUrl("");
    });
  }

  //股权结构this
  guquanjiegou() {
    let params = {companyId: this.companyId, companyName: this.companyName, page: this.params.page};
    this.guDongService.getBasicInfo(params, 1).subscribe(data => {
      //console.log('股权结构');
      //console.log(data);
      if (data.stateCode == "60111") {
        let list = [];
        if (this.isFromQi) {
          this.companyPartnersResult.totalCount = data.data.totalRecords;
          data.data.list.forEach(item => list.push(new CompanyPartner(item, this.isFromQi)));
        } else {
          this.companyPartnersResult.totalCount = data.data.totalCount;
          data.data.returnData.forEach(item => list.push(new CompanyPartner(item, this.isFromQi)));
        }
        this.companyPartnersResult.page = params.page;
        this.companyPartnersResult.list = list;
        this.companyPartnersResult.list.forEach(item=>{
          this.guDongService.getCompanyByName(item.stockName).subscribe(result=>{
            if (result.data) {
              item.isCompany = true;
            }
          });
        });
      } else {
        this.companyPartnersResult = null;
      }
    }, (err) => {
    });


  }

  //对外投资
  investInfo() {
    let params = {companyId: this.companyId, companyName: this.companyName, page: this.params.page};
    this.guDongService.getBasicInfo(params, 2).subscribe(data => {
      //console.log('对外投资');
      //console.log(data);
      if (data.stateCode == "60111") {
        let list = [];
        if (this.isFromQi) {
          this.investInfoResult.totalCount = data.data.Paging.TotalRecords;
          data.data.Result.forEach(item => list.push(new InvestInfo(item, this.isFromQi)));
        } else {
          this.investInfoResult.totalCount = data.data.totalCount;
          data.data.returnData.forEach(item => list.push(new InvestInfo(item, this.isFromQi)));
        }
        this.investInfoResult.page = params.page;
        this.investInfoResult.list = list;
      } else {
        this.investInfoResult = null;
      }
    }, (err) => {
      //this.router.navigateByUrl("");
    });
  }

  //招投标
  operationTender() {
    let params = {companyId: this.companyId, companyName: this.companyName, page: this.params.page};
    this.guDongService.getBasicInfo(params, 19).subscribe(data => {
      //console.log('招投标');
      //console.log(data);
      if (data.stateCode == "60111") {
        let list = [];
        if (this.isFromQi) {// 企查查接口
          this.operationTenderResult.totalCount = data.data.Paging.TotalRecords;
          data.data.Result.forEach(item => list.push(new OperationTender(item, this.isFromQi)));
        } else {

        }
        this.operationTenderResult.page = params.page;
        this.operationTenderResult.list = list;
      } else {
        this.operationTenderResult = null;
      }
    }, (err) => {
      //this.router.navigateByUrl("");
    });
  }

  //著作权信息-q
  getOperationCopyright() {
    let params = {companyId: this.companyId, companyName: this.companyName, page: this.params.page};
    this.guDongService.getBasicInfo(params, 20).subscribe(data => {
      if (data.stateCode == "60111") {
        let list = [];
        if (this.isFromQi) {// 企查查接口
          this.copyrightResult.totalCount = data.data.Paging.TotalRecords;
          data.data.Result.forEach(item => list.push(new Copyright(item, this.isFromQi)));
        } else {
          this.copyrightResult.totalCount = data.data.totalCount;
          data.data.returnData.forEach(item => list.push(new Copyright(item, this.isFromQi)));
        }
        this.copyrightResult.page = params.page;
        this.copyrightResult.list = list;
      } else {
        this.copyrightResult = null;
      }
    }, (err) => {
    });
  }

  //网站信息-q
  getOperationWebsite() {
    let params = {companyId: this.companyId, companyName: this.companyName, page: this.params.page};
    this.guDongService.getBasicInfo(params, 21).subscribe(data => {
      if (data.stateCode == "60111") {
        let list = [];
        if (this.isFromQi) {// 企查查接口
          this.websiteResult.totalCount = data.data.Paging.TotalRecords;
          data.data.Result.forEach(item => list.push(new Website(item, this.isFromQi)));
        } else {
          this.websiteResult.totalCount = data.data.totalCount;
          data.data.returnData.forEach(item => list.push(new Website(item, this.isFromQi)));
        }
        this.websiteResult.page = params.page;
        this.websiteResult.list = list;
      } else {
        this.websiteResult = null;
      }
    }, (err) => {
    });
  }

  //证书信息-q
  getAssetCertification() {
    let params = {companyId: this.companyId, companyName: this.companyName, page: this.params.page};
    this.guDongService.getBasicInfo(params, 22).subscribe(data => {
      if (data.stateCode == "60111") {
        let list = [];
        if (this.isFromQi) {// 企查查接口
          this.certificationResult.totalCount = data.data.Paging.TotalRecords;
          data.data.Result.forEach(item => list.push(new Certification(item, this.isFromQi)));
        } else {
          this.certificationResult.totalCount = data.data.totalCount;
          data.data.returnData.forEach(item => list.push(new Certification(item, this.isFromQi)));
        }
        this.certificationResult.page = params.page;
        this.certificationResult.list = list;
      } else {
        this.certificationResult = null;
      }
    }, (err) => {
    });
  }

  //融资信息-q
  getOperationFinancing() {
    let params = {companyId: this.companyId, companyName: this.companyName, page: this.params.page};
    this.guDongService.getBasicInfo(params, 23).subscribe(data => {
      if (data.stateCode == "60111") {
        let list = [];
        if (this.isFromQi) {// 企查查接口
          this.financingResult.totalCount = data.data.totalRecords;
          data.data.list.forEach(item => list.push(new Financing(item, this.isFromQi)));
        } else {
          this.financingResult.totalCount = data.data.totalCount;
          data.data.returnData.forEach(item => list.push(new Financing(item, this.isFromQi)));
        }
        this.financingResult.page = params.page;
        this.financingResult.list = list;
      } else {
        this.financingResult = null;
      }
    }, (err) => {
    });
  }

  //财务信息
  getOperationFinancingTax() {
    let params = {companyId: this.companyId, companyName: this.companyName, page: this.params.page};
    this.guDongService.getBasicInfo(params, 24).subscribe(data => {
      if (data.stateCode == "60111") {
        let list = [];
        if (this.isFromQi) {// 企查查接口
          this.financingTaxResult.totalCount = data.data.totalCount;
          data.data.returnData.forEach(item => list.push(new FinancingTax(item, this.isFromQi)));
        } else {
          this.financingTaxResult.totalCount = data.data.totalCount;
          data.data.returnData.forEach(item => list.push(new FinancingTax(item, this.isFromQi)));
        }
        this.financingTaxResult.page = params.page;
        this.financingTaxResult.list = list;
      } else {
        this.financingTaxResult = null;
      }
    }, (err) => {
    });
  }

  //产品信息-q
  getOperationProduct() {
    let params = {companyId: this.companyId, companyName: this.companyName, page: this.params.page};
    this.guDongService.getBasicInfo(params, 25).subscribe(data => {
      if (data.stateCode == "60111") {
        let list = [];
        if (this.isFromQi) {// 企查查接口
          this.productResult.totalCount = data.data.Paging.TotalRecords;
          data.data.Result.forEach(item => list.push(new Product(item, this.isFromQi)));
        } else {
          this.productResult.totalCount = data.data.totalCount;
          data.data.returnData.forEach(item => list.push(new Product(item, this.isFromQi)));
        }
        this.productResult.page = params.page;
        this.productResult.list = list;
      } else {
        this.productResult = null;
      }
    }, (err) => {
    });
  }

  //抽查信息
  getOperationSpotcheck() {
    let params = {companyId: this.companyId, companyName: this.companyName, page: this.params.page};
    this.guDongService.getBasicInfo(params, 26).subscribe(data => {
      console.log(data);
      if (data.stateCode == "60111") {
        let list = [];
        if (this.isFromQi) {// 企查查接口
          this.spotcheckResult.totalCount = data.data.totalRecords;
          data.data.list.forEach(item => list.push(new Spotcheck(item, this.isFromQi)));
        } else {
          this.spotcheckResult.totalCount = data.data.totalCount;
          data.data.returnData.forEach(item => list.push(new Spotcheck(item, this.isFromQi)));
        }
        this.spotcheckResult.page = params.page;
        this.spotcheckResult.list = list;
      } else {
        this.spotcheckResult = null;
      }
    }, (err) => {
    });
  }

  //行政处罚信息
  getDetailOperationPenalty() {
    let params = {companyId: this.companyId, companyName: this.companyName, page: this.params.page};
    this.guDongService.getBasicInfo(params, 27).subscribe(data => {
      if (data.stateCode == "60111") {
        let list = [];
        if (this.isFromQi) {// 企查查接口
          this.penaltyResult.totalCount = data.data.totalRecords;
          data.data.list.forEach(item => list.push(new Penalty(item, this.isFromQi)));
        } else {
          this.penaltyResult.totalCount = data.data.totalCount;
          data.data.returnData.forEach(item => list.push(new Penalty(item, this.isFromQi)));
        }
        this.penaltyResult.page = params.page;
        this.penaltyResult.list = list;
      } else {
        this.penaltyResult = null;
      }
    }, (err) => {
    });
  }

  openEnterprise(companyName) {
    this.guDongService.getCompanyByName(companyName).subscribe(result => {
      if (result.data) {
        window.open('/enterpBasicArchives?userId=' + this.userId + '&userName=' + this.userName
          + '&fromType=' + this.fromType + '&companyId=' + result.data.companyId);
      }
    });
  }

  /**
   * 滚动调用接口，以解决页面加载慢的问题
   */
  scrollInvokeData() {
    let thiss = this;
    $(window).scroll(function () {
      // 页面滚动的距离
      let scrollTop = $(window).scrollTop();

      // 需要展示数据的div距离屏幕顶部的距离
      // 股权类信息
      var a = $("#gqlxx").offset().top;
      // 如果滚动到对应的div位置加载对应的接口
      if ((scrollTop + $(window).height()) >= a) {
        if (!thiss.gqlxxInit) {
          thiss.gqlxxInit = true;
          thiss.guquanjiegou();
          thiss.investInfo();
          thiss.branch();
        }
      }

      // 历史沿革
      var b = $("#lsyg").offset().top;
      // 如果滚动到对应的div位置加载对应的接口
      if ((scrollTop + $(window).height()) >= b) {
        if (!thiss.lsygInit) {
          thiss.lsygInit = true;
          thiss.change();
          thiss.scopeChange();
        }
      }

      // 知识产权信息
      var c = $("#zscqxx").offset().top;
      // 如果滚动到对应的div位置加载对应的接口
      if ((scrollTop + $(window).height()) >= c) {
        if (!thiss.zscqxxInit) {
          thiss.zscqxxInit = true;
          thiss.patentDetail();
          thiss.softwareCopyrights();
          thiss.getOperationCopyright();
          thiss.getOperationWebsite();
          thiss.getAssetCertification();
        }
      }

      // 商标信息
      var d = $("#sbxx").offset().top;
      // 如果滚动到对应的div位置加载对应的接口
      if ((scrollTop + $(window).height()) >= d) {
        if (!thiss.sbxxInit) {
          thiss.sbxxInit = true;
          thiss.tmInfo();
        }
      }

      // 经营状况
      var de = $("#jyzk").offset().top;
      // 如果滚动到对应的div位置加载对应的接口
      if ((scrollTop + $(window).height()) >= de) {
        if (!thiss.jyzkInit) {
          thiss.jyzkInit = true;
          thiss.getOperationFinancing();
          thiss.getOperationFinancingTax();
          thiss.getOperationProduct();
        }
      }

      // 履约结果信息
      var e = $("#lyjgxx").offset().top;
      // 如果滚动到对应的div位置加载对应的接口
      if ((scrollTop + $(window).height()) >= e) {
        if (!thiss.lyjgxxInit) {
          thiss.lyjgxxInit = true;
          thiss.mPledge();
          thiss.pledge();
          thiss.liquidation();
          thiss.opException();
        }
      }

      // 司法信息
      var f = $("#sfxx").offset().top;
      // 如果滚动到对应的div位置加载对应的接口
      if ((scrollTop + $(window).height()) >= f) {
        if (!thiss.sfxxInit) {
          thiss.sfxxInit = true;
          thiss.execute();
          thiss.loseCreditExecute();
          thiss.caseB();
          thiss.chinacourt();

          thiss.getOperationSpotcheck();
          thiss.getDetailOperationPenalty();
        }
      }

      // 舆情和其他公开信息
      var g = $("#yqhqtgkxx").offset().top;
      // 如果滚动到对应的div位置加载对应的接口
      if ((scrollTop + $(window).height()) >= g) {
        if (!thiss.yqhqtgkxxInit) {
          thiss.yqhqtgkxxInit = true;
          thiss.newsInfo();
          thiss.recruitInfo();
          if (thiss.isFromQi) {// 仅企查查才有数据的接口
            thiss.operationTender();
          }
        }
      }
    });
  }


  ready() {

    $('html,body').animate({scrollTop: $('.jbxx').offset().top - 650}, 800);

    $("#firstpane .menu_body:eq(0)").show();
    $("#firstpane h3.menu_head").click(function () {
      $(this).addClass("current").next("div.menu_body").slideToggle(300).siblings("div.menu_body").slideUp("slow");
      $(this).siblings().removeClass("current");
    });

    $("#secondpane .menu_body:eq(0)").show();
    $("#secondpane h3.menu_head").mouseover(function () {
      $(this).addClass("current").next("div.menu_body").slideDown(500).siblings("div.menu_body").slideUp("slow");
      $(this).siblings().removeClass("current");
    });
    $('.scl_jbxx').click(function () {
      $('html,body').animate({scrollTop: $('.jbxx').offset().top - 150}, 800);
    });
    /*模块都码上去后请按照这种格式继续往下接，不然跳转太生硬*/
    $('.scl_gqlxx').click(function () {
      $('html,body').animate({scrollTop: $('.gqlxx').offset().top - 120}, 800);
    });
    $('.scl_lsyg').click(function () {
      $('html,body').animate({scrollTop: $('.lsyg').offset().top - 120}, 800);
    });
    $('.scl_zscqxx').click(function () {
      $('html,body').animate({scrollTop: $('.zscqxx').offset().top - 120}, 800);
    });
    $('.scl_sbxx').click(function () {
      $('html,body').animate({scrollTop: $('.sbxx').offset().top - 120}, 800);
    });
    $('.scl_djgdwrzxx').click(function () {
      $('html,body').animate({scrollTop: $('.djgdwrzxx').offset().top - 120}, 800);
    });
    $('.scl_jyzk').click(function () {
      $('html,body').animate({scrollTop: $('.jyzk').offset().top - 120}, 800);
    });
    $('.scl_dcdy').click(function () {
      $('html,body').animate({scrollTop: $('.dcdy').offset().top - 150}, 800);
    });
    $('.scl_gqcz').click(function () {
      $('html,body').animate({scrollTop: $('.gqcz').offset().top - 120}, 800);
    });
    $('.scl_zscqcz').click(function () {
      $('html,body').animate({scrollTop: $('.zscqcz').offset().top - 120}, 800);
    });
    $('.scl_qsxx').click(function () {
      $('html,body').animate({scrollTop: $('.qsxx').offset().top - 120}, 800);
    });
    $('.scl_gsycml').click(function () {
      $('html,body').animate({scrollTop: $('.gsycml').offset().top - 120}, 800);
    });
    $('.scl_sfxx').click(function () {
      $('html,body').animate({scrollTop: $('.sfxx').offset().top - 120}, 800);
    });
    $('.scl_choucha').click(function () {
      $('html,body').animate({scrollTop: $('.choucha').offset().top - 120}, 800);
    });
    $('.scl_xzcf').click(function () {
      $('html,body').animate({scrollTop: $('.xzcf').offset().top - 120}, 800);
    });
    $('.scl_qyyqxx').click(function () {
      $('html,body').animate({scrollTop: $('.qyyqxx').offset().top - 120}, 800);
    });
    $('.scl_ztbxx').click(function () {
      $('html,body').animate({scrollTop: $('.ztbxx').offset().top - 120}, 800);
    });
    $('.scl_zplxx').click(function () {
      $('html,body').animate({scrollTop: $('.zplxx').offset().top - 120}, 800);
    });
    /*大的*/
    $('.scl_jcxyzlxx').click(function () {
      $('html,body').animate({scrollTop: $('.jcxyzlxx').offset().top - 150}, 800);
    });
    $('.scl_lyjgxx').click(function () {
      $('html,body').animate({scrollTop: $('.lyjgxx').offset().top - 120}, 800);
    });
    $('.scl_yqhqtgkxx').click(function () {
      $('html,body').animate({scrollTop: $('.yqhqtgkxx').offset().top - 120}, 800);
    });
    var nav = $(".menu_list"); //得到导航对象

    var win = $(document); //得到窗口对象

    win.scroll(function () {
      if (win.scrollTop() >= 400) {

        nav.addClass("Lbarfix");
      } else {

        nav.removeClass("Lbarfix");
      }

    });
  }

  /**
   * 下载报告
   */
  creditReportDownload() {
    let companyName = this.companyName || this.companyInfo.name;
    let gdUserId = sessionStorage.getItem('gd_userId');
    let gdUserName = sessionStorage.getItem('gd_userName');
    // let imageData = JSON.stringify(this.saveImage('enterMap'));
    this._isSpinning = true;
    // 生成图片 base64字符串
    let shareContent = document.getElementById('enterMap');//需要截图的包裹的（原生的）DOM 对象
    let width = d3.select('svg').attr('width'); //宽度
    let height = d3.select('svg').attr('height'); //高度
    let canvas = document.createElement("canvas"); //创建一个canvas节点
    let scale = 1; //定义任意放大倍数 支持小数
    canvas.width = width * scale; //定义canvas 宽度 * 缩放
    canvas.height = height * scale; //定义canvas高度 *缩放
    canvas.getContext("2d").scale(scale, scale); //获取context,设置scale
    var opts = {
      scale: scale, // 添加的scale 参数
      canvas: canvas, //自定义 canvas
      logging: false, //日志开关
      width: width, //dom 原始宽度
      height: height //dom 原始高度
    };
    html2canvas(shareContent, opts).then(can => {
      let canvasImg = can.toDataURL("image/png");
      // 开始生成报告
      this.httpService.post('/enterprise/detail/xhsRest/report/createReportByGD',
        {companyId: this.companyId, companyName: companyName,
          userId: gdUserId, userName: gdUserName, imageData: canvasImg}).subscribe(result=>{
        this._isSpinning = false;
        if (result.stateCode == '1') { // 成功 开始下载报告
          this.httpService.locationUrlGet2("/enterprise/detail/xhsRest/report/downloadReportByGD",
            {path: result.data, companyId: this.companyId, userId: gdUserId, userName: gdUserName});
        } else if (result.stateCode == '103') { // 达到上限
          this.showAlert.error({content: '当前用户今日下载次数已达到上限！',okText: '确认'});
        } else if (result.stateCode == '120') { // 达到上限
          this.showAlert.error({content: '当前用户今年下载总次数已达到上限！',okText: '确认'});
        } else { // 失败
          this.showAlert.error({content: '系统错误，请稍候再试！',okText: '确认'});
        }
      });
    },  (err) => {
      console.log(err);
      this._isSpinning = false;
      this.showAlert.error({content: '系统错误，请稍候再试！',okText: '确认'});
    });
  }

  ngAfterViewInit() {
    var This = this;
    var tree;
    var svg;
    var linkContainer;
    var nodes;
    var links;
    var container;
    var zoom;
    var resultData;
    $(function(){
      if (This.companyId) {
        $("#enterMap").html('');
        This.httpService.get("/enterprise/detail/xhsRest/baseMsg/getCompanyInfo",
          {"companyId": This.companyId}).subscribe(data => {
          if (data.data.returnData!=null) {
            let companyName = data.data.returnData[0].name;
            This.httpService.get("/enterprise/detail/xhsRest/enterMap/getTreeCompanyMapByQcc",
              {keyword: companyName}).subscribe(result =>{
              resultData = result.data;
              // initMap(result.data);
              traverseTreeId(resultData);
              draw(resultData);
              // 加载完成，显示信用报告下载按钮
              This.showDownloadBtn = true;
              scrollTo(0,1);
            });
          }
        });
      }
    });
    function initMap(resultData1) {
      traverseTreeId(resultData1);
      draw(resultData1);
    }
    //遍历树
    function traverseTreeId(node){
      var id = 1;
      trId(node);
      function trId(node1){
        if(!node1.id){
          node1.id = id;
          id++;
        }
        if(node1.children){
          for(var i=0; i<node1.children.length; i++){
            trId(node1.children[i]);
          }
        }
      }
    }
    //绘画图谱
    function draw(root){
      tree = d3.layout.cluster().size([360, 600]).separation(function(a, b) { return (a.parent == b.parent ? 2:3) / a.depth; });
      $("#enterMap").empty();
      svg = d3.select("#enterMap").append("svg").attr("xmlns","http://www.w3.org/2000/svg");
      svg.empty();
      d3.select('svg').attr('width',$('#enterMap').width());
      d3.select('svg').attr('height',$('#enterMap').height());
      container = svg.append("g");
      linkContainer = container.append("g");
      zoom = d3.behavior.zoom().scaleExtent([0.4, 2]).on("zoom", zoomed);
      svg.call(zoom);
      initLocation();
      function zoomed() {
        container.attr("transform", "translate(" + d3.event.translate + ")scale(" + d3.event.scale + ")");
      }
      function initLocation(){
        zoom.translate([svg.attr('width')/2,svg.attr('height')/2]);
        zoom.scale(0.8);
        container.attr("transform", "translate("+zoom.translate()+")scale("+zoom.scale()+")");
      }
      drawTree(root);
    }
    //处理树
    function drawTree(data) {
      var diagonal = d3.svg.diagonal.radial().projection(function(d) { return [d.y, d.x / 180 * Math.PI]; });
      data.x0=0;
      data.y0=0;
      nodes = tree.nodes(resultData);
      links = tree.links(nodes);
      var pathLength = 150;
      if(nodes.length>100){
        pathLength = 200;
      }
      nodes.forEach(function(d) {
        if(d.depth>2){
          d.y = d.depth * (d.depth/2) * 150;
        }else{
          d.y = d.depth * pathLength;
        }
      });
      var linkUpdate = linkContainer.selectAll(".link").data(links,function(d){ return d.target.id; });
      var linkEnter = linkUpdate.enter();
      var linkExit = linkUpdate.exit();
      linkEnter.append("path").attr("class", "link").attr("d", function(d) {
        var o = {x: data.x0, y: data.y0};
        return diagonal({source: o, target: o});
      }).transition().duration(500).attr("d", diagonal);
      linkUpdate.attr("stroke", function (d) {
        if(d.source.Category==2|| d.target.Category==2){
          return "#7ec56a";
        }
        if(d.source.Category==3|| d.target.Category==3){
          return "#728dc9";
        }
        if(d.source.Category==4|| d.target.Category==4){
          return "#65d289";
        }
        if(d.source.Category==5|| d.target.Category==5){
          return "#a496c7";
        }
        if(d.source.Category==6|| d.target.Category==6){
          return "#ee7698";
        }
        return "#f35151";
      }).transition().duration(500).attr("d", diagonal)
        .attr("style", "fill: none; stroke-opacity: 1; stroke: #9ecae1; stroke-width: 1px;");
      linkExit.transition().duration(500).attr("d", function(d) {
        var o = {x: data.x, y: data.y};
        return diagonal({source: o, target: o});
      }).remove();
      var nodeUpdate = container.selectAll(".node").data(nodes,function(d){ return d.id; });
      var nodeEnter = nodeUpdate.enter();
      var nodeExit = nodeUpdate.exit();
      var enterNodes = nodeEnter.append("g").attr("class", function(d) { return "node"; })
        .attr("transform", function(d) { return "translate(" + project(data.x0, data.y0) + ")"; });
      enterNodes.append("circle").attr("r", 0).attr("fill",function(d){
        if(d.Category==1){
          return "#40bfd5";
        }
        if(d.Category==2){
          return "#7ec56a";
        }
        if(d.Category==3){
          return "#728dc9";
        }
        if(d.Category==4){
          return "#65d289";
        }
        if(d.Category==5){
          return "#a496c7";
        }
        if(d.Category==6){
          return "#ee7698";
        }
        return "#40bfd5";
      }).attr("stroke", function (d) {
        if(d.depth==0){
          return "#40bfd5";
        }
        if(d.depth==1){
          if(d.Category==1){
            return "#40bfd5";
          }
          if(d.Category==2){
            return "#7ec56a";
          }
          if(d.Category==3){
            return "#728dc9";
          }
          if(d.Category==4){
            return "#65d289";
          }
          if(d.Category==5){
            return "#a496c7";
          }
          if(d.Category==6){
            return "#ee7698";
          }
        }
        return null;
      }).attr("stroke-opacity",0.5).attr("stroke-width", function (d) {
        if(d.depth==0){
          return 10;
        }
        if(d.depth==1){
          return 6;
        }
        return 0;
      }).on("click", function (d) {
        if(d.depth>0){
          toggle(d);
          drawTree(d);
        }
      });
      enterNodes.append("path").attr("d", function (d) {
        if(d.depth>0 && d._children){
          return "M-6 -1 H-1 V-6 H1 V-1 H6 V1 H1 V6 H-1 V1 H-6 Z";
        }else if(d.depth>0 && d.children){
          return "M-6 -1 H6 V1 H-6 Z";
        }
      }).attr("fill","#ffffff").attr("stroke","#ffffff").attr("stroke-width","0.2").on("click", function (d) {
        if(d.depth>0){
          toggle(d);
          drawTree(d);
        }
      });
      enterNodes.append("text").attr("dy", function(d){
        if(d.depth==0){
          return "-1.5em";
        }
        return "0.31em";
      }).attr("x", function(d) {
        if(d.depth==0){
          return d.name.length*8;
        }
        return d.x < 180 ? 15 : -15;
      }).text(function(d) { return d.name; }).style("text-anchor", function(d) {
        if(d.depth==0){
          return "end";
        }
        return d.x < 180 ? "start" : "end";
      }).style("fill-opacity", 0).attr("transform", function(d) {
        if(d.depth>0){
          return "rotate(" + (d.x < 180 ? d.x - 90 : d.x + 90) + ")";
        }else{
          return "rotate(0)";
        }
      }).style("font-size", function (d) {
        if(d.depth==0){
          return "16px";
        }
        return "14px";
      }).attr("fill", function (d) {
        if(d.depth==0){
          return "#2c91e8";
        }
        if(d.depth==1){
          if(d.Category==2){
            return "#2db092";
          }
          if(d.Category==3){
            return "#3d4cd4";
          }
        }
        return "#333";
      });
      var updateNodes = nodeUpdate.transition().duration(500)
        .attr("transform", function(d) { return "translate(" + project(d.x, d.y) + ")"; });
      updateNodes.select("text").style("fill-opacity", 1).attr("transform", function(d) {
        if(d.depth>0){
          return "rotate(" + (d.x < 180 ? d.x - 90 : d.x + 90) + ")";
        }else{
          return "rotate(0)";
        }
      }).attr("x", function(d) {
        if(d.depth==0){
          return d.name.length*8;
        }
        return d.x < 180 ? 15 : -15;
      }).attr("fill", function (d) {
        if(d.depth==0){
          return "#2c91e8";
        }
        if(d.depth==1){
          if(d.Category==2){
            return "#2db092";
          }
          if(d.Category==3){
            return "#3d4cd4";
          }
        }
        return "#333";
      }).style("text-anchor", function(d) {
        if(d.depth==0){
          return "end";
        }
        return d.x < 180 ? "start" : "end";
      });
      updateNodes.select("circle").attr("r", function (d) {
        if(d.depth==0){
          return 12;
        }
        if(d.depth==1){
          return 10;
        }
        return 9;
      });
      updateNodes.select("path").attr("d", function (d) {
        if(d.depth>0 && d._children){
          return "M-6 -1 H-1 V-6 H1 V-1 H6 V1 H1 V6 H-1 V1 H-6 Z";
        }else if(d.depth>0 && d.children){
          return "M-6 -1 H6 V1 H-6 Z";
        }
      });
      var exitNodes=nodeExit.transition().duration(500)
        .attr("transform", function(d) { return "translate(" + project(data.x, data.y) + ")"; }).remove();
      exitNodes.select("circle").attr("r", 0);
      exitNodes.select("text").style("fill-opacity", 0);
      nodes.forEach(function(d) {
        d.x0 = d.x;
        d.y0 = d.y;
      });
    }
    function toggle(d){
      if (d.children) {
        d._children = d.children;
        d.children = null;
      } else {
        d.children = d._children;
        d._children = null;
      }
    }
    function project(x, y) {
      var angle = (x - 90) / 180 * Math.PI, radius = y;
      return [radius * Math.cos(angle), radius * Math.sin(angle)];
    }

    /*function saveImage(svgDivId) : any {
      let shareContent = document.getElementById(svgDivId);//需要截图的包裹的（原生的）DOM 对象
      let width = d3.select('svg').attr('width'); //宽度
      let height = d3.select('svg').attr('height'); //高度
      let canvas = document.createElement("canvas"); //创建一个canvas节点
      let scale = 1; //定义任意放大倍数 支持小数
      canvas.width = width * scale; //定义canvas 宽度 * 缩放
      canvas.height = height * scale; //定义canvas高度 *缩放
      canvas.getContext("2d").scale(scale, scale); //获取context,设置scale
      var opts = {
        scale: scale, // 添加的scale 参数
        canvas: canvas, //自定义 canvas
        logging: true, //日志开关
        width: width, //dom 原始宽度
        height: height //dom 原始高度
      };
      html2canvas(shareContent, opts).then(canvas2 => {
        This.canvasImg = canvas2.toDataURL("image/png");
        // console.log(canvas2);
        // $('#testImage').attr('src', This.canvasImg);
        scrollTo(0,1);
        $('#' + svgDivId).hide();
      });
    }*/

  }

}

export class Params {
  public page: Page;

  constructor() {
    this.page = new Page();
  }
}




// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/components/enterp-basic-archives/enterp-basic-archives.component.ts